import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbvue/lib/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Vue from "vue";
import App from "./App";
import router from "./router";
import { firestorePlugin } from "vuefire";
import firebase from "firebase/app";
import "firebase/firestore";
Vue.use(firestorePlugin);
Vue.use(require("vue-moment"));

var firebaseConfig = {
  apiKey: "AIzaSyCUvPqEHIEz2kpjntqGf2j9KBdqkUQ_xig",
  authDomain: "portfolio-ms.firebaseapp.com",
  databaseURL: "https://portfolio-ms.firebaseio.com",
  projectId: "portfolio-ms",
  storageBucket: "",
  messagingSenderId: "1058108304674",
  appId: "1:1058108304674:web:a0e9fa56c81a7a76",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});
